import React, {
    Component, createRef, 
    // useContext, 
    useState} from 'react';

import { Row } from 'react-bootstrap';

import FormInput from '../../Component/Utilities/FormInput/FormInput';
import PrimaryButton from '../../Component/Utilities/PrimaryButton/PrimaryButton';

import './ResetPasswordPage.scss';

import UtilityFunction from '../../Util/Util'

// import Init from '../../Init/Init';
import CustomToast from '../../Component/Utilities/Toast/Toast';
import authAPI from '../../Data/Auth';
import LoadingPage from '../../Component/Utilities/LoadingPage/LoadingPage';

const { convertQueryToObj } = UtilityFunction;

const ResetPasswordForm = ({ resetToken, passwordRef, confirmPasswordRef, displayToast }) => {
    const [ disableButton, setDisableButton ] = useState(true);
    const [ isSubmitting, setIsSubmitting ] = useState(false);

    const checkPassword = () => {
        const allFilled = passwordRef.ref.current.value !== "" && confirmPasswordRef.ref.current.value !== "";

        if( allFilled && disableButton ) {
            setDisableButton(false);
        } else if( !allFilled && !disableButton ) {
            setDisableButton(true);
        }
    }

    const resetPassword = async () => {
        setIsSubmitting(true);

        const password = passwordRef.ref.current.value;
        const confirmPassword = confirmPasswordRef.ref.current.value;

        const response = await authAPI.resetPassword(resetToken, password, confirmPassword);

        if( response.hasOwnProperty('errorCode') && response.errorCode === 0 ) {
            // Success toast, clear form
            displayToast({
                title: "Success",
                message: response.message,
                status: 1,
                show: 1,
            });

            setDisableButton(true);
            setTimeout(() => {
                window.location.href = "/login";
            }, 5000);
        } else {
            // Failed toast
            displayToast({
                title: "Failed",
                message: response.message,
                status: 0,
                show: 1,
            });
        }

        setIsSubmitting(false);
    }

    return (
        <div className="reset-password-container">
            <h3 className="reset-password-title">
                Reset Password
            </h3>
            <p className="text-center"> Kesempatan untuk mengubah password hanya 15 menit dari halaman ini pertama kali dibuka. Silahkan verifikasi ulang email apabila melewati batas waktu yang diberikan. </p>
            <div className="reset-password-form">
                <Row>
                    <FormInput
                        name={'password'}
                        attribute={ passwordRef }
                        onChange={() => checkPassword()}
                    />
                    <FormInput
                        name={'confirmPassword'}
                        attribute={ confirmPasswordRef }
                        onChange={() => checkPassword()}
                    />
                </Row>
            </div>
            <div className="reset-password-btn-container">
                {
                    isSubmitting ? (
                        <LoadingPage />
                    ) : (
                        <PrimaryButton disabled={ disableButton } customClass='reset-password-btn' size='sm' onClick={ () => resetPassword() }>
                            Ubah Password
                        </PrimaryButton>
                    )
                }
            </div>
        </div>
    );
}

class ResetPasswordPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            password: {
                label: 'Password',
                ref: createRef(),
                placeholder: 'Masukkan password',
                width: 12,
                required: true,
                type: "password",
                autoComplete: "off"
            },
            confirmPassword: {
                label: 'Konfirmasi Password',
                ref: createRef(),
                placeholder: 'Konfirmasi password',
                width: 12,
                required: true,
                type: "password",
                autoComplete: "off"
            },
            toast: {
                title: "",
                status: 0,
                show: 0,
                message: ""
            },
            isAllowResetPassword: false,
            resetToken: ""
        }
    }

    componentDidMount() {
        window.addEventListener('resize', function(event){});
        const urlParams = convertQueryToObj(window.location.search);
        const token = urlParams.reset_token;
        console.log(token);
        if( token ) {
            console.log(token);
            (async () => {
                const response = await authAPI.verifyResetPasswordToken(token);

                if( response.hasOwnProperty('errorCode') && response.errorCode === 0 ) {
                    this.setState({
                        ...this.state,
                        resetToken: token,
                        isAllowResetPassword: true
                    });
                } else {
                    window.location.href = "/login";
                    console.log("Failed API Call!");
                    // this.setState({
                    //     ...this.state,
                    //     resetToken: token,
                    //     isAllowResetPassword: true
                    // });
                }
            })();
        } else {
            window.location.href = "/login";
            // console.log("Token does not exists!");
        }
    }

    componentDidUpdate() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    
    componentWillUnmount() {
        this.setState = (state,callback)=>{
            return;
        };

        window.removeEventListener('resize', () => {});
    }

    displayToast(content) {
        this.setState({
            ...this.state,
            toast: {
                ...content
            }
        });
    }

    closeToast() {
        const state = {...this.state};
        const toast = state.toast;

        this.setState({
            ...state,
            toast: {
                ...toast,
                show: 0,
            }
        });
    }

    render() {
        return (
            <div className='reset-password-page'>
                <CustomToast 
                    title={this.state.toast.title}
                    status={this.state.toast.status}
                    show={this.state.toast.show}
                    onClose={() => this.closeToast()}
                >
                    { this.state.toast.message }
                </CustomToast>
                {
                    this.state.isAllowResetPassword ? (
                        <ResetPasswordForm 
                            resetToken={this.state.resetToken}
                            passwordRef={this.state.password} 
                            confirmPasswordRef={this.state.confirmPassword}
                            displayToast={ (content) => this.displayToast(content) }
                        />
                    ) : (
                        <LoadingPage />
                    )
                }
            </div>
        );
    }
}

export default ResetPasswordPage;